import { render, staticRenderFns } from "./systemConf.vue?vue&type=template&id=1db7125a&"
import script from "./systemConf.vue?vue&type=script&lang=js&"
export * from "./systemConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "systemConf.vue"
export default component.exports